<template>
  <div>
    <section class="text-gray-600 body-font relative newsBgClass pb-14">
      <div class="container m-auto  flex">
        <div
          class="px-4 m-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 flex flex-col lg:m-auto md:m-auto w-full mt-10 md:mt-0 relative z-10 justify-center">
          <div
            class="px-4 py-10 sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-8 lg:px-8 lg:py-14 bg-white rounded-lg newsBoxClass shadow-md">
            <div class="flex justify-center items-center pb-10">
              <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
              <p class="w-40 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest">新闻动态</p>
              <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            </div>

            <div class="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 md:max-w-full lg:max-w-screen-xl">

              <div @click="toNews(5)" class="cursor-pointer">
                <img
                  class="object-cover newsImg"
                  :src="baseOSSUrl + '/newsCount5-1.png'"
                  alt="Person"
                  importance="high"
                />
                <div class="flex flex-col justify-center mt-2 p-2">
                  <p class="text-base font-bold">欧洲医疗服务中心与第十一届盘古大血管疾病论坛合作圆满成功</p>
                  <p class="text-sm tracking-wide text-gray-400 mt-2 newsIntroduceClass">
                    欧洲医疗服务中心与第十一届盘古大血管疾病论坛合作圆满成功
                  </p>
                </div>
              </div>

              <div @click="toNews(1)" class="cursor-pointer">
                <img
                  class="object-cover newsImg"
                  :src="baseOSSUrl + '/newsCount1-1.png'"
                  alt=""
                  importance="high"
                />
                <div class="flex flex-col justify-center mt-2 p-2">
                  <p class="text-base font-bold">中欧专家远程连线，共话心血管诊疗</p>
                  <p class="text-sm tracking-wide text-gray-400 mt-2 newsIntroduceClass">
                    中欧专家远程连线，共话心血管诊疗
                  </p>
                </div>
              </div>

              <div @click="toNews(2)" class="cursor-pointer">
                <img
                  class="object-cover newsImg"
                  :src="baseOSSUrl + '/doctor1.png'"
                  alt=""
                  importance="high"
                />
                <div class="flex flex-col justify-center mt-2 p-2">
                  <p class="text-base font-bold">中欧国际心血管教育和交流项目顺利召开</p>
                  <p class="text-sm tracking-wide text-gray-400 mt-2 newsIntroduceClass">
                    中欧国际心血管教育和交流项目顺利召开
                  </p>
                </div>
              </div>

              <div @click="toNews(3)" class="cursor-pointer">
                <img
                  class="object-cover newsImg"
                  :src="baseOSSUrl + '/ag2.png'"
                  alt="Person"
                  importance="high"
                />
                <div class="flex flex-col justify-center mt-2 p-2">
                  <p class="text-base font-bold">蔡奇书记一行走访调研银山集团孵化企业-瑷格干细胞</p>
                  <p class="text-sm tracking-wide text-gray-400 mt-2 newsIntroduceClass">
                    蔡奇书记一行走访调研银山集团孵化企业-瑷格干细胞
                  </p>
                </div>
              </div>

              <!-- <div @click="toNews(4)" class="cursor-pointer">
                <img class="object-cover newsImg" :src="baseOSSUrl + '/ag.png" alt="Person" />
                <div class="flex flex-col justify-center mt-2 p-2">
                  <p class="text-base font-bold">瑷格干细胞研发中心启动仪式成功举行</p>
                  <p class="text-sm tracking-wide text-gray-400 mt-2 newsIntroduceClass">
                    瑷格干细胞研发中心启动仪式成功举行
                  </p>
                </div>
              </div> -->

            </div>
            <a class="inline-flex items-center mt-4 text-sm understandMoreColor cursor-pointer float-right"
              @click="toNews()">更多
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7"></path>
              </svg>
            </a>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss';
import "swiper/dist/css/swiper.css";
import {
swiper,
swiperSlide
} from 'vue-awesome-swiper';
  export default {
    name: 'homeNews',
    components: {
      // BScroll,
      swiper,
      swiperSlide
    },
    data() {
      return {
        baseOSSUrl,
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    methods: {
      toNews(item) {
        let path = item ? '/newsContent' : '/newsList'
        this.$router.push({
          path: path,
          query: item ? {
            newsIndex: item
          } : ''
        })
      }
    }
  }
</script>

<style>
  .understandMoreColor {
    color: #123B7F;
  }

  /* 超过5行文字就省略*/
  .newsIntroduceClass {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  .newsBgClass {
    background-color: #F1F4FB;
  }

  .newsBoxClass {
    margin-top: -3rem !important;
  }

  .newsImg {
    /* width: 16.5625rem;
    height: 11.25rem; */
  }


  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/right.png");
    background-size: 27px;
    /* right: 30px; */
    left: auto;
  }

  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/left.png");
    background-size: 27px;
    /* left: 30px; */
    right: auto;
  }
</style>